import { createContext } from 'react';

export const EthereumContext = createContext({ });
